// @flow
export default () => ({
    root: {},
    label: {},
    select: {},
    errorMessage: {},
});
